import React from 'react';

import GAException from 'src/components/GAException';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function AuthRouteRegisterOrFromMiCabal({ children }) {
  const account = useSelector((state) => state.account);
  //const { user } = useSelector((state) => state.account);

  if (!account.user) {
    return <Redirect to="/login" />;
  }

  if (!account.user.flagUserActivate && !account.user.flagUsuarioMiCabal) {
    return <Redirect to='/app/mensajes/registro/completar/debecompletar' />;
  }

  return children;
}

AuthRouteRegisterOrFromMiCabal.propTypes = {
  children: PropTypes.any
};

export default AuthRouteRegisterOrFromMiCabal;
